<template>
    
  <div class="container">
    <div class="pagination_box">
      <el-pagination
        layout="prev, pager, next"
        :total="parseInt(pageData.total)"
        :page-size="parseInt(pageData.pageSize)"
        @current-change="handleCurrentChange"
        :prev-text="$t('lang.external.fzsy.content.home.上一页')"
        :next-text="$t('lang.external.fzsy.content.home.下一页')"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: ['pageData'],
  data() {
    return {}
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {
    handleCurrentChange(val) {
      this.$emit('chagePage', val)
    },
  },
}
</script>

<style lang="scss" scoped>
.container  {
  width: 100%;
}
.pagination_box {
  padding-top: 22px;
  padding-bottom: 18px;
  ::v-deep {
    .el-pagination {
      text-align: center;
    }
    .el-pager li {
      width: 34px;
      height: 34px;
      margin: 0px 3px 0px 3px;
      border-radius: 3px;
      line-height: 34px;
    }
    .el-pagination .btn-next {
      height: 34px;
      border-radius: 3px;
      padding-right: 10px;
      color: #666666;
      font-weight: bold;
      margin-left: 11px;
    }
    .el-pagination .btn-prev {
      height: 34px;
      border-radius: 3px;
      padding-right: 10px;
      color: #666666;
      font-weight: bold;
      margin-right: 11px;
      box-sizing: border-box;
      font-size: 12px;
    }
    .el-pagination .el-pager li:not(.disabled).active {
      background-color: rgba(#0c5893, 1);
      color: #fff;
    }
  }
}
</style>